// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__nA9XN","overlay":"Hero_overlay__ZLr78","heroContent":"Hero_heroContent__7kjMG"};